import * as React from 'react';
import { ClickAwayListener, makeStyles, Tooltip, Typography, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { String_Split_SplitEvenlyCountLockToolTip, String_Split_SplitEvenlyInstruction } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { CheckStateContext } from '../../providers/CheckStateContextProvider';
import themePrimary from '../../styles/themePrimary';
import { CheckClaimSummary } from '../../models/common/CheckClaimSummary';
import SelectField, { SelectFieldChangeHandler, SelectFieldProps, SelectLabelOrientation } from '../common/SelectField'

const useStyles = makeStyles({
    innerContainer: {
        display: 'flex',
        marginLeft: 'auto',
        marginRight: 'auto'
    },
    outerContainer: {
        width: '100%',
        display: 'flex',
    },
    instructionText: {
        textAlign: 'center',
        marginLeft: ElementDimensions.margin5 + 'px',
        marginRight: ElementDimensions.margin5 + 'px',
        marginBottom: ElementDimensions.margin10 + 'px ',
    },
    root: {
        padding: ElementDimensions.padding20 + 'px',
        backgroundColor: themePrimary.palette.grey[100],
        width: '100%',
    },
    splitText1: {
        textAlign: 'right',
        marginRight:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
    splitText2: {
        textAlign: 'center',
        marginLeft:  ElementDimensions.margin10 + 'px ',
        marginRight:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
    splitText3: {
        textAlign: 'left',
        marginLeft:  ElementDimensions.margin10 + 'px ',
        lineHeight: '40px',
    },
});

export type SplitEvenlyCountChangeHandler = (newValue: number) => any;

export interface SplitEvenlyProps {
    claimSummary: CheckClaimSummary | null;
    onCountChangeHandler: SplitEvenlyCountChangeHandler;
}

const SplitEvenly = (props: SplitEvenlyProps) => {
    const { claimSummary, onCountChangeHandler } = props;
    const isPortrait = true;
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const [toolTipOpen, setToolTipOpen] = React.useState<boolean>(false);
    const [splitEvenlyCount, setSplitEvenlyCount] = React.useState<number>((): number => {
        return (claimSummary !== null && claimSummary.split_evenly_count !== null) ? 
            claimSummary.split_evenly_count : checkState.state.splitEvenlyCount});
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleTooltipClose = () => {
        setTimeout(() => {setToolTipOpen(false);}, 2000);
    };

    const handleTooltipOpen = () => {
        setToolTipOpen(true);
    };

    const getSplitCountKeyValues = () => {
        let kvps: { key: string, value: string }[] = [];
    
        for (var i = 2; i <= 12; i++) {
            kvps.push({ key: i.toString(), value: i.toString()});
        }
        
        return kvps;
    }

    const handleSplitCountSelectChange: SelectFieldChangeHandler = (event: React.ChangeEvent<{ value: unknown }>) => {
        let newCount = parseInt(event.target.value as string);
        setSplitEvenlyCount(newCount);
        onCountChangeHandler(newCount);
    };

    const splitCountSelectProps: SelectFieldProps = {
        size: 'sm',
        minWidth: 80,
        label: '',
        disabled:false,
        labelOrientation: SelectLabelOrientation.Top,
        selectedValue: splitEvenlyCount.toString(),
        keyValues: getSplitCountKeyValues(),
        onChangeHandler: handleSplitCountSelectChange,
    };

    return (
        <div className={classes.root}>

            <Typography variant="body1" className={classes.instructionText}>
                {String_Split_SplitEvenlyInstruction.find(s => s.key === userState.state.locale)!!.value}
            </Typography>

            <div className={classes.outerContainer}>
                <div className={classes.innerContainer}>
                    {claimSummary !== null && claimSummary.split_evenly_count !== null &&    
                        <ClickAwayListener onClickAway={handleTooltipClose}>
                            <Tooltip
                                arrow
                                disableHoverListener
                                disableFocusListener
                                onClose={handleTooltipClose}
                                open={toolTipOpen}
                                title={String_Split_SplitEvenlyCountLockToolTip.find(s => s.key === userState.state.locale)!!.value}>
                                <div onClick={handleTooltipOpen}>
                                    <SelectField
                                        size={splitCountSelectProps.size}
                                        minWidth={splitCountSelectProps.minWidth}
                                        label={splitCountSelectProps.label}
                                        disabled={true}
                                        labelOrientation={splitCountSelectProps.labelOrientation}
                                        onChangeHandler={splitCountSelectProps.onChangeHandler}
                                        selectedValue={splitCountSelectProps.selectedValue}
                                        keyValues={splitCountSelectProps.keyValues} />
                                </div>                                
                            </Tooltip>
                        </ClickAwayListener>                        
                    }

                    {claimSummary === null || claimSummary.split_evenly_count === null &&                    
                        <SelectField
                            size={splitCountSelectProps.size}
                            minWidth={splitCountSelectProps.minWidth}
                            label={splitCountSelectProps.label}
                            disabled={splitCountSelectProps.disabled}
                            labelOrientation={splitCountSelectProps.labelOrientation}
                            onChangeHandler={splitCountSelectProps.onChangeHandler}
                            selectedValue={splitCountSelectProps.selectedValue}
                            keyValues={splitCountSelectProps.keyValues} />
                    }

                </div>
            </div>
        </div>
    );
};

export default SplitEvenly;
